import React, { useState, useEffect } from "react";
import "../Assets/Styles/WebDesign.css";
import { IMAGES } from "../utils";
import { GiCheckMark } from "react-icons/gi";
import { AnimationOnScroll } from "react-animation-on-scroll";
import Testimonials from "../sections/Testimonials";
import RegisterationPopUp from "../auth/RegistrationPopUp";

const WebDesign = () => {
  const web = [
    { web: "HTML5" },
    { web: "CSS3" },
    { web: "Javascript" },
    { web: "Bootstrap" },
  ];
  const [showModal, setShowModal] = useState(false);
  // const handleClose = () => setShowModal(false);

  const handleClose = () => {
    setShowModal(false);
    setTimeout(() => setShowModal(true), 50000);
  };
  useEffect(() => {
    setTimeout(() => setShowModal(true), 50000);
  }, []);
  return (
    <>
      <RegisterationPopUp
        show={showModal}
        setShow={setShowModal}
        handleClose={handleClose}
      />
      <div className="web-course-section">
        <section className="web-course-wrapper">
          <div className="web-course-subwrapper">
            <div className="web-design-crs-banner">
              <div className=" web-design-banner-content">
                <div className="container">
                  <h3>Learn Web Design Course in Pune</h3>
                  <p>
                    <strong>
                      <a href="https://codehubtech.com/" target="_blank">
                        Code Hub Technology
                      </a>
                    </strong>{" "}
                    is a well-known institute in Pune that offers a variety of
                    courses, including web design. they offer both classroom &
                    online training options & provide practical training on live
                    projects.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="what-is-web">
                <div className="col-lg-6">
                  <div className="webcourse-right">
                    <div className="webcourse-right-content">
                      <div className="webdesign-crs-title">
                        <h3>What Is Web Design Course ?</h3>
                      </div>
                      <div className="webCourse-text">
                        <p>
                          A web design course is a training program that teaches
                          individuals how to create and design websites. The
                          course typically covers a range of topics, including
                          HTML, CSS, JavaScript, Web Design principles, User
                          Experience Design, and Responsive Design.
                        </p>
                        <p>
                          {" "}
                          In a web design course, students learn how to create
                          visually appealing and user-friendly websites, using a
                          range of design principles, such as Typography, Color
                          Theory, and Layout. They also learn about User
                          experience design, which focuses on creating websites
                          that are easy to navigate and use. Responsive Design
                          is another important topic covered in web design
                          courses.
                        </p>
                        <p>
                          Responsive design ensures that a website looks good
                          and functions well on different devices, such as
                          Desktops, Laptops, Tablets, and Smartphones.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6"></div>
              </div>
            </div>
          </div>
        </section>

        <section className="what-is-ui-section">
          <div className="container what-is-ui-wrapper">
            <div className="row">
              <div className="col-lg-5">
                <div className="ui-image-wrapper">
                  <img
                    src={IMAGES.WhatIsUserInterfaceUI}
                    className="crs-ui-img"
                    alt="what is ui img"
                  />
                </div>
              </div>
              <div className="col-lg-7">
                {/* <div className="curve"></div> */}
                <div className="ui-content-wrapper">
                  <div>
                    <h3>What Is User Interface (UI)?</h3>
                    <p>
                      User Interface (UI) refers to the visual and interactive
                      elements of a software application or website that allows
                      users to interact with the system. It includes all the
                      elements that a user sees and interacts with on the
                      Screen, such as Buttons, Menus, Icons, Forms, and other
                      graphical elements.
                    </p>
                    <p>
                      The main goal of UI is to make the interaction between the
                      user and the system as smooth, efficient, and intuitive as
                      possible. It is the responsibility of the UI designer to
                      create a visual and interactive design that is easy to
                      use, aesthetically pleasing, and accessible to a wide
                      range of users.
                    </p>
                    <p>
                      UI design involves several key elements, including Layout,
                      Typography, Color Scheme, and Visual Hierarchy. The layout
                      refers to the arrangement of elements on the screen, while
                      typography refers to the choice of fonts and how they are
                      used. The color scheme involves the use of colors to
                      create a visual identity for the application or website,
                      while visual hierarchy involves the use of design elements
                      to guide the user's attention to the most important
                      elements on the screen.
                    </p>
                    <p>
                      UI design is an important part of the overall user
                      experience (UX) design, which encompasses all aspects of
                      the user's interaction with the system, including the
                      Functionality, Usability, and Accessibility of the system.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="what-is-ux-section">
          <div className="container what-is-ux-wrapper">
            <div className="row">
              <div className="col-lg-7">
                <div className="ux-content-wrapper">
                  <div>
                    <h3>What Is User Experience (UX)? </h3>
                    <p>
                      User Experience (UX) refers to the overall experience that
                      a user has when interacting with a software application or
                      website. It encompasses all aspects of the user's
                      interaction with the system, including the Functionality,
                      Usability, Accessibility and overall satisfaction with the
                      experience.
                    </p>
                    <p>
                      UX design is the process of designing and improving the
                      user experience of a product, with the aim of making it
                      more intuitive, easy to use, and enjoyable for the user.
                      UX designers work to understand the needs and goals of the
                      users, and to design a product that meets those needs in
                      the most efficient and effective way possible.
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-lg-5">
                <div className="ux-image-wrapper">
                  <img
                    src={IMAGES.WhatIsUserExperience}
                    className="crs-ux-img"
                    alt="what is ux img"
                  />
                </div>
              </div>
            </div>
            <div className="what-is-ux-bottom">
              <p>
                UX design involves several key elements, including User
                Research, User Interface Design, Interaction Design, and
                Information Architecture. User research involves gathering
                information about the users, their needs, goals, and behaviors,
                while user interface design involves designing the visual and
                interactive elements of the product.
              </p>
              <p>
                Interaction design involves designing the way that users
                interact with the product, while information architecture
                involves designing the structure and organization of the
                information within the product.
              </p>
            </div>
          </div>
        </section>

        <section className="tab-content-section">
          <div className="container">
            <nav className="nav-class">
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className="nav-link active"
                  id="nav-html-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-html"
                  type="button"
                  role="tab"
                  aria-controls="nav-html"
                  aria-selected="true"
                >
                  HTML
                </button>
                <button
                  className="nav-link"
                  id="nav-css-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-css"
                  type="button"
                  role="tab"
                  aria-controls="nav-css"
                  aria-selected="false"
                >
                  CSS
                </button>
                <button
                  className="nav-link"
                  id="nav-js-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-js"
                  type="button"
                  role="tab"
                  aria-controls="nav-js"
                  aria-selected="false"
                >
                  JavaScript
                </button>

                <button
                  className="nav-link"
                  id="nav-bootstrap-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-bootstrap"
                  type="button"
                  role="tab"
                  aria-controls="nav-bootstrap"
                  aria-selected="false"
                >
                  Bootstrap
                </button>

                <button
                  className="nav-link"
                  id="nav-wordPress-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-wordPress"
                  type="button"
                  role="tab"
                  aria-controls="nav-wordPress"
                  aria-selected="false"
                >
                  Wordpress
                </button>

                <button
                  className="nav-link"
                  id="nav-react-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#nav-react"
                  type="button"
                  role="tab"
                  aria-controls="nav-react"
                  aria-selected="false"
                >
                  ReactJs
                </button>
              </div>
            </nav>
            <div className="tab-content" id="nav-tabContent">
              <div
                className="tab-pane fade show active"
                id="nav-html"
                role="tabpanel"
                aria-labelledby="nav-html-tab"
              >
                <section className="section-html">
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="js-image-wrapper">
                          <img
                            src={IMAGES.HTML}
                            className="crs-js-img"
                            alt="what is js img"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="html-content-wrapper">
                          <div className="html-content">
                            <p>
                              HTML stands for Hypertext Markup Language. It is
                              the standard markup language used for creating and
                              structuring the content of web pages and
                              applications on the internet.
                            </p>
                            <p>
                              HTML uses a set of tags to define the structure
                              and presentation of the content within a web page.
                            </p>
                            <p>
                              HTML is the backbone of the World Wide Web and is
                              utilized by web developers, designers, and content
                              creators to create web pages that can be rendered
                              by web browsers. It provides a standardized way to
                              structure text, images, links, multimedia
                              elements, forms, and more.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="tab-pane fade"
                id="nav-css"
                role="tabpanel"
                aria-labelledby="nav-css-tab"
              >
                <section className="section-css">
                  <div className="container css-wrapper">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="css-content-wrapper">
                          <div className="css-content">
                            <p>
                              CSS stands for Cascading Style Sheets, and it is a
                              styling language used to describe the presentation
                              and layout of HTML (Hypertext Markup Language) and
                              XML (Extensible Markup Language) documents. CSS
                              allows web developers to control the appearance of
                              web pages by separating the content from its
                              visual representation.
                            </p>
                            <p>
                              CSS works by selecting HTML or XML elements and
                              applying styles to them, such as font size, color,
                              background color, border style, and layout. Styles
                              can be applied to elements directly or inherited
                              from parent elements, and can be applied in
                              multiple ways, including inline, internal, and
                              external stylesheets.
                            </p>
                            <p>
                              Inline styles are styles applied directly to an
                              HTML element using the style attribute, while
                              internal styles are defined in the head section of
                              an HTML document using the style tag. External
                              stylesheets are defined in separate CSS files that
                              are linked to an HTML document using the link tag.
                            </p>
                            <p>
                              CSS also includes advanced features such as
                              selectors, which allow developers to target
                              specific elements based on their attributes, class
                              names, and relationships to other elements in the
                              document. CSS also supports responsive design,
                              which allows developers to create web pages that
                              adapt to different screen sizes and device types.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="css-image-wrapper">
                          <img
                            src={IMAGES.CSS}
                            className="crs-css-img"
                            alt="what is css img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
              <div
                className="tab-pane fade"
                id="nav-js"
                role="tabpanel"
                aria-labelledby="nav-js-tab"
              >
                <section className="section-js">
                  <div className="container js-wrapper">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="js-image-wrapper">
                          <img
                            src={IMAGES.JavaScript}
                            className="crs-js-img"
                            alt="what is js img"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="js-content-wrapper">
                          <div className="js-content">
                            <p>
                              JavaScript is a programming language that is
                              commonly used to create interactive and dynamic
                              web pages. It is a high-level, interpreted
                              language that runs in the browser and is designed
                              to work seamlessly with HTML and CSS.
                            </p>
                            <p>
                              JavaScript is used to add functionality to web
                              pages, such as validating forms, creating dynamic
                              effects, and responding to user actions. It can
                              also be used to create complex web applications
                              and games.
                            </p>
                            <p>
                              JavaScript is a versatile language that can be
                              used for both client-side and server-side
                              development. On the client-side, JavaScript is
                              used to create interactive web pages that respond
                              to user input, while on the server-side, it can be
                              used to create web applications and APIs.
                            </p>
                            <p>
                              JavaScript includes a range of built-in functions
                              and objects that make it easy to manipulate HTML
                              elements, create animations, and perform other
                              common web development tasks. It also includes
                              support for object-oriented programming, event
                              handling, and asynchronous programming, which
                              makes it well-suited for developing complex web
                              applications.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div
                className="tab-pane fade"
                id="nav-bootstrap"
                role="tabpanel"
                aria-labelledby="nav-bootstrap-tab"
              >
                <section className="section-bootstrap">
                  <div className="container bootstrap-wrapper">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="bootstrap-content-wrapper">
                          <div className="bootstrap-content">
                            <p>
                              Bootstrap is a free, open-source front-end
                              framework for creating responsive, mobile-first
                              web pages and web applications. It was developed
                              by Twitter and is now maintained by a large
                              community of developers.
                            </p>
                            <p>
                              Bootstrap includes a range of HTML, CSS, and
                              JavaScript components and tools, such as
                              responsive grid layouts, typography, forms,
                              buttons, navigation menus, modals, carousels, and
                              more. These components can be used to create
                              consistent and visually appealing web pages and
                              user interfaces quickly and easily.
                            </p>
                            <p>
                              Bootstrap also includes a responsive design system
                              that allows developers to create web pages that
                              adapt to different screen sizes and device types,
                              such as desktops, laptops, tablets, and
                              smartphones. This makes it ideal for creating
                              mobile-friendly web pages and web applications.
                            </p>
                            <p>
                              Bootstrap is easy to learn and use, and is
                              well-documented with a large community of
                              developers and users. It is also customizable,
                              with the ability to modify and extend the
                              framework to meet specific design and
                              functionality requirements.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="bootstrap-image-wrapper">
                          <img
                            src={IMAGES.Bootstrap}
                            className="crs-bootstrap-img"
                            alt="what is bootstrap img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div
                className="tab-pane fade"
                id="nav-wordPress"
                role="tabpanel"
                aria-labelledby="nav-wordPress-tab"
              >
                <section className="section-wordPress">
                  <div className="container wordpress-wrapper">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="wordpress-image-wrapper">
                          <img
                            src={IMAGES.Wordpress}
                            className="crs-wordpress-img"
                            alt="what is bootstrap img"
                          />
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="wordpress-content-wrapper">
                          <div className="wordpress-content">
                            <p>
                              WordPress is a free, open-source content
                              management system (CMS) that is used to create and
                              manage websites, blogs, and online stores. It is
                              built on PHP and MySQL, and is designed to be
                              user-friendly and flexible, with a range of
                              customization options and plugins available.
                            </p>
                            <p>
                              WordPress allows users to easily create and
                              publish content on the web, with a range of
                              built-in tools and features for creating pages,
                              posts, menus, and more. It also includes a range
                              of themes and templates, which allow users to
                              customize the look and feel of their website
                              without the need for extensive coding or design
                              skills.
                            </p>
                            <p>
                              WordPress also includes a range of plugins, which
                              are third-party add-ons that can be used to extend
                              the functionality of a WordPress website. These
                              plugins can be used to add features such as social
                              media integration, e-commerce functionality,
                              contact forms, SEO optimization, and more.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              <div
                className="tab-pane fade"
                id="nav-react"
                role="tabpanel"
                aria-labelledby="nav-react-tab"
              >
                <section className="section-react">
                  <div className="container react-wrapper">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="react-content-wrapper">
                          <div className="wordpress-content">
                            <p>
                              ReactJS, commonly referred to as React, is an
                              open-source JavaScript library used for building
                              user interfaces (UIs) for web applications.
                              Developed by Facebook, React allows developers to
                              create reusable UI components and efficiently
                              manage the application state.
                            </p>
                            <p>
                              It follows a component-based architecture, where
                              complex UIs are broken down into smaller,
                              independent components.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="wordpress-image-wrapper">
                          <img
                            src={IMAGES.Wordpress}
                            className="crs-wordpress-img"
                            alt="what is bootstrap img"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="section-web-eligibility">
          <div className="web-eligibility">
            <div className="container eligibility-heading">
              <h3>Course Eligibility</h3>
            </div>
            <div className="eligibility-section">
              <div className="container">
                <div className="row">
                  {web?.map((w, idx) => (
                    <div className="col-lg-3" key={idx}>
                      <div className="web-eligibility-list">
                        <GiCheckMark size={20} className="eligibility-icon" />
                        <p>{w.web}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section> */}

        <section className="testimonials">
          <div className="container">
            <div className="test-heading">
              <h3>Testimonials</h3>
              <h5>
                The feedback we've received from clients about working with us.
              </h5>
            </div>

            <div className="testimonial-section">
              <div className="row">
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="testimonial-outer-wrapper">
                    <div className="testimonial-inner-wrapper">
                      <div className="testimonial-profile">
                        <img src={IMAGES.pujabhole} alt="" />
                        <div className="testimonial-profile-name">
                          <h4>Puja Bhole</h4>
                          <p className="testimonial-company-name">
                            Power BI Developer
                          </p>
                          <p className="testimonial-desc">
                            The Code Hub Technology Institute was a game-changer
                            for me.I gained valuable skills in coding, UI/UX
                            design, and responsive web development. The
                            institute provided a supportive learning
                            environment, and I'm now confident in my abilities
                            to pursue a career in web design. Highly recommend!"
                          </p>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="testimonial-outer-wrapper">
                    <div className="testimonial-inner-wrapper">
                      <div className="testimonial-profile">
                        <img src={IMAGES.photo} alt="" />
                        <div className="testimonial-profile-name">
                          <h4>Pratik Patil</h4>
                          <p className="testimonial-company-name">Developer</p>
                          <p className="testimonial-desc">
                            The instructors were top-notch professionals who
                            truly cared about our success.The institute also
                            offered career guidance and job placement
                            assistanceI am grateful for the knowledge and skills
                            I gained at Code Hub Technology Institute and would
                            recommend it to anyone passionate about web design."
                          </p>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12">
                  <div className="testimonial-outer-wrapper">
                    <div className="testimonial-inner-wrapper">
                      <div className="testimonial-profile">
                        <img src={IMAGES.photo} alt="" />
                        <div className="testimonial-profile-name">
                          <h4>kishor Patil</h4>
                          <p className="testimonial-company-name">
                            Graphics Designer
                          </p>
                          <p className="testimonial-desc">
                            "Enrolling at Code Hub Technology Institute was one
                            of the best decisions I made.The class emphasized
                            practical skills, and I felt confident in my
                            abilities upon graduation. I'm grateful for the
                            opportunities Code Hub Technology Institute provided
                            and highly recommend their web design program."
                          </p>
                          <span></span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="testimonial-outer-wrapper">
                  <div className="testimonial-inner-wrapper">
                    <div className="testimonial-profile">
                        <img src={IMAGES.Profile} alt="" / />
                        <div className="testimonial-profile-name">
                        <h4>Lorem Ispum</h4>
                        <p className="testimonial-company-name">DThrill Software Solutions LLP</p>
                        <p className="testimonial-desc">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s</p>
                        <span></span>
                        </div>
                    </div>
                  </div>
                </div>
              </div> */}
              </div>
            </div>
          </div>
        </section>

        <section className="faq-web-section">
          <div className="container ">
            <div className="faq-web-title">
              <h3 className="text-center">Frequency Ask Qutions</h3>
            </div>
            <div className="row faqsection">
              <div className="col-lg-7 col-md-6 col-sm-12">
                <div
                  className="accordion accordion-flush"
                  id="accordionFlushExample"
                >
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingOne">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseOne"
                        aria-expanded="false"
                        aria-controls="flush-collapseOne"
                      >
                        1. Do you arrange a Demo Class?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseOne"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingOne"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, we organize demo classes, this session gives you
                          understanding of the whole course.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseTwo"
                        aria-expanded="false"
                        aria-controls="flush-collapseTwo"
                      >
                        2. Do you provide Placement ?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseTwo"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingTwo"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        {" "}
                        <p>
                          Yes, we provide placement to our students after
                          completing this course from our institute & Depends On
                          Students Capacity
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseThree"
                        aria-expanded="false"
                        aria-controls="flush-collapseThree"
                      >
                        3. Which Certificates will I get?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseThree"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingThree"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        <p>
                          We Provide Course Completion Certificates after
                          Completing the Web Designing Course.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFour"
                        aria-expanded="false"
                        aria-controls="flush-collapseFour"
                      >
                        4. What if I miss some lectures?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFour"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFour"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Attending previous batches will allow you to catch up
                          on the lectures and subjects you missed.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFive"
                        aria-expanded="false"
                        aria-controls="flush-collapseFive"
                      >
                        5. Do you provide Internships?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFive"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, we have dedicated course for the students who
                          need Internships after completion of course.
                        </p>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <h2 className="accordion-header" id="flush-headingFive">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#flush-collapseFive"
                        aria-expanded="false"
                        aria-controls="flush-collapseFive"
                      >
                        6. Can I pay my fees in installments ?
                      </button>
                    </h2>
                    <div
                      id="flush-collapseFive"
                      className="accordion-collapse collapse"
                      aria-labelledby="flush-headingFive"
                      data-bs-parent="#accordionFlushExample"
                    >
                      <div className="accordion-body">
                        <p>
                          Yes, 3 installments are available for Website
                          Designing long term courses
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-5 col-md-6 col-sm-12">
                <div className="faq-web-img-wrapper">
                  <AnimationOnScroll animateIn="animate__tada" offset={5}>
                    <img src={IMAGES.faqGd} className="faq-que-web-img" />
                  </AnimationOnScroll>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default WebDesign;
